import React, { memo } from 'react';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ModalHeaderProps } from 'ducks/types/prop-types';
import { useSwitchTheme } from 'hooks/useSwitchTheme';

import cn from 'components/modal-header/ModalHeader.module.scss';

const ModalHeaderBase = ({ page, onReturn, children }: ModalHeaderProps) => {
  const { theme } = useSwitchTheme();

  if (page === 0) {
    return (
      <div
        className={cn.container}
        style={{
          color: theme.font_color,
          backgroundColor: theme.element_background,
          borderBottom: theme.border,
        }}
      >
        <h2 className={cn.header}>{children}</h2>
      </div>
    );
  }

  return (
    <div
      className={cn.container}
      onClick={onReturn}
      style={{
        cursor: 'pointer',
        color: theme.font_color,
        backgroundColor: theme.element_background,
        borderBottom: theme.border,
      }}
    >
      <FontAwesomeIcon icon={faChevronLeft} />
      <h2 className={cn.header}>{children}</h2>
    </div>
  );
};

export const ModalHeader = memo(ModalHeaderBase);
